import React, {
  FunctionComponent,
  useEffect,
  useState,
} from "react";
import { styled, useTheme, Theme, CSSObject } from '@mui/material/styles';
import Box from '@mui/material/Box';
import MuiDrawer from '@mui/material/Drawer';
import MuiAppBar, { AppBarProps as MuiAppBarProps } from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import List from '@mui/material/List';
import CssBaseline from '@mui/material/CssBaseline';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import AnalyticsIcon from '@mui/icons-material/Analytics';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import './sideNavBar.style.css';
import { connect, useDispatch } from 'react-redux';
import {themeColors} from "../../Components/theme";
import ContactsIcon from '@mui/icons-material/Contacts';
import TaskIcon from '@mui/icons-material/Task';
import PersonIcon from '@mui/icons-material/Person';
import ListAltIcon from '@mui/icons-material/ListAlt';
import LanguageIcon from '@mui/icons-material/Language';
import PaymentIcon from '@mui/icons-material/Payment';
import PhoneIcon from '@mui/icons-material/Phone';
import LiveHelpIcon from '@mui/icons-material/LiveHelp';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import GroupsIcon from '@mui/icons-material/Groups';
import NewspaperIcon from '@mui/icons-material/Newspaper';
import ToggleOnIcon from '@mui/icons-material/ToggleOn';
import ApartmentIcon from '@mui/icons-material/Apartment';
import PasswordIcon from '@mui/icons-material/Password';
import SettingsIcon from '@mui/icons-material/Settings';
import LeadList from '@mui/icons-material/List';
import AuditLog from '@mui/icons-material/PieChartOutlined';
import InfoIcon from '@mui/icons-material/Info';
import CloudSyncIcon from '@mui/icons-material/CloudSync';
// import { googleAnalyticsTabClick } from "../../Services/users";
import Broadcast from "../../Assets/Images/campaign-nav-image.png";
import BroadcastWhite from "../../Assets/Images/campaign-nav-image-white.png";
import NewLabel from "../../Assets/Images/new-label.png";
import { googleAnalyticsMMBTabClick, googleAnalyticsTabClick } from "../../Services/users";
import ReportWhiteIcon from '../../Assets/Images/report-white-icon.svg'
import ReportBlackIcon from '../../Assets/Images/report-black-icon.svg'
import ViewCarouselIcon from '@mui/icons-material/ViewCarousel';
import PostAddOutlinedIcon from '@mui/icons-material/PostAddOutlined';

const drawerWidth = 200;

const openedMixin = (theme: Theme): CSSObject => ({
  width: drawerWidth,
  border:"none",
  fontFamily: "Poppins",
  fontWeight: "bold",
  fontSize: "0.8rem",
  boxShadow: '0 2px 2px 0 rgba(0, 0, 0, 0.2), 0 1px 2px 0 rgba(0, 0, 0, 0.19)',
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: 'hidden',
  zIndex:200
});

const closedMixin = (theme: Theme): CSSObject => ({
  border:"none",
  fontFamily: "Poppins",
  fontWeight: "bold",
  fontSize: "0.8rem",
  zIndex:200,
  boxShadow: '0 2px 2px 0 rgba(0, 0, 0, 0.2), 0 1px 2px 0 rgba(0, 0, 0, 0.19)',
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: 'hidden',
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up('sm')]: {
    width: `calc(${theme.spacing(8)} + 1px)`,
  },
});

const DrawerHeader = styled('div')(({ theme: any }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
}));

interface AppBarProps extends MuiAppBarProps {
  open?: boolean;
}

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== 'open',
})<AppBarProps>(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(['width', 'margin'], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

const Drawer = styled(MuiDrawer, { shouldForwardProp: (prop) => prop !== 'open' })(
  ({ theme, open }) => ({
    width: drawerWidth,
    flexShrink: 0,
    border:"none",
    whiteSpace: 'nowrap',
    boxSizing: 'border-box',
    ...(open && {
      ...openedMixin(theme),
      '& .MuiDrawer-paper': openedMixin(theme),
    }),
    ...(!open && {
      ...closedMixin(theme),
      '& .MuiDrawer-paper': closedMixin(theme),
    }),
  }),
);

type props = {
  props?: any;
  title:
  | "Organizations"
  | "Contacts"
  | "Users"
  | "Bookings"
  | "Drilldown";
  path?: string;
  leadManger?: Boolean;
  operationManger?: Boolean;
  project?: string;
  task?: string;
  resources?: string;
  callLogs?: string;
  faq?: string;
  user: any;
  api?: string;
  news?: string;
  apiData?: string;
  integrations?: string;
  leadDistributor?: string;
  customButton?: string;
  appTheme:any;
  updatePassword?: string;
  organizationData:any;
  organsationSettting?: string;
  userPreference?: any;
  help?:any;
  mmb?:any;
  lockSideNavbar?:boolean;
  accessAllowedMarketingAutomation?: boolean;
  showReportTab?: boolean;
  bannerManagement?:string;
  hasActiveWAPackage?: boolean;
  WAAgentActiveStatus?:any;
};
const MiniDrawer: FunctionComponent<props> = ({
  props,
  title,
  path,
  leadManger,
  operationManger,
  project,
  task,
  resources,
  callLogs,
  faq,
  user,
  api,
  news,
  apiData,
  integrations,
  leadDistributor,
  customButton,
  appTheme,
  updatePassword,
  organizationData,
  organsationSettting,
  userPreference,
  help,
  mmb,
  lockSideNavbar,
  accessAllowedMarketingAutomation,
  showReportTab,
  bannerManagement,
  hasActiveWAPackage,
  WAAgentActiveStatus
}) => {
  const theme = useTheme();
  const [open, setOpen] = React.useState(true);
  const dispatcher = useDispatch();
  const [autoToken,setAutoToken]=React.useState("");
  const [userOid,setUserOid]=React.useState(null);

 useEffect(()=>{
  let userData: any = localStorage.getItem("user");
  let parsedUser = JSON.parse(userData);

  // console.log("rishabh side nav bar ",user)
  setUserOid(parsedUser.user_oid)
    if(parsedUser.autoToken){
      setAutoToken(parsedUser.autoToken)
    }
 },[])
 
  const handleDrawer = () => {
    if (!open) {
      setOpen(true);
    }
    else {
      setOpen(false);
    }

  };

  const sideNavbarContainer = {
    backgroundColor:
    appTheme ? themeColors.sidebarBackgroundColor:themeColors.sidebarBackgroundColorDark,
    color:appTheme ? themeColors.textPrimary:themeColors.textPrimaryDark
  }
  const iconColor={
    color:appTheme ? themeColors.iconColor:themeColors.iconColorDark
  }

  // console.log("side navbar WAAgentActiveStatus",WAAgentActiveStatus,hasActiveWAPackage);
  return (
    <Box className="containerSideBar" sx={{ display: 'flex'}} >
      <Drawer variant="permanent" open={open} sx={{...sideNavbarContainer}}>
        <DrawerHeader sx={{...sideNavbarContainer,marginBottom:"-10px"}} >
          <IconButton onClick={handleDrawer} style={{...iconColor}}>
            {open ? <ChevronLeftIcon /> :<div style={{marginRight:"1rem"}}> <MenuIcon /></div>}
          </IconButton>
        </DrawerHeader>
        <Divider />
        <List style={{ 
          paddingBottom: "100px",
          // height:"900px",
          // paddingBottom: "20px",
          flex:1,
          ...sideNavbarContainer
          }}>

          {/* Before Admin Profile Changes  */}
          {/* {title !== "Drilldown" && title !== "Users" && operationManger !== true && (
            <ListItem disablePadding sx={{ display: 'block' }}
              style={{
                backgroundColor: "/analytics" ===
                  props.history.location.pathname ? "#279f9f" : appTheme ? themeColors.sidebarBackgroundColor:themeColors.sidebarBackgroundColorDark,
                color: "/analytics" ===
                  props.history.location.pathname ? "#FFFFFF" :"", cursor: "pointer"
              }}
              onClick={() => {
                googleAnalyticsTabClick("Analytics_Tab",user)
                props.history.push("/analytics");
              }}
            >
              <ListItemButton
                sx={{
                  minHeight: 48,
                  justifyContent: open ? 'initial' : 'center',
                  px: 2.5,
                }}

              >
                {    props.history.location.pathname === "/analytics" ?
                 <ListItemIcon
                 sx={{
                   minWidth: 0,
                   mr: open ? 3 : 'auto',
                   justifyContent: 'center',
                  color: "#fff"
                 }}
               >
                 <AnalyticsIcon />
               </ListItemIcon>: 
               <ListItemIcon
                  sx={{
                    minWidth: 0,
                    mr: open ? 3 : 'auto',
                    justifyContent: 'center',
                    ...iconColor
                  }}
                >
                  <AnalyticsIcon />
                </ListItemIcon>  
              }
              
                <ListItemText primary={"Analytics"}
                  sx={{ opacity: open ? 1 : 0 }} />
              </ListItemButton>
              {!open ? <span>Analytics</span> : ''}
            </ListItem>
          )} */}
          
          {/* After Admin Profile Changes */}

          {
            (user.profile === "Operation Manager") && (
              <ListItem disablePadding sx={{ display: 'block' }}
                style={{
                  backgroundColor: path === props.history.location.pathname ? "#279f9f" : appTheme ? themeColors.sidebarBackgroundColor : themeColors.sidebarBackgroundColorDark,
                  color: path ===
                    props.history.location.pathname ? "#FFFFFF" : "", cursor: "pointer"
                }}
                onClick={() => {
                  googleAnalyticsTabClick("Booking_Tab",user)
                  props.history.push(path);
                }}
              >
                <ListItemButton
                  sx={{
                    minHeight: 48,
                    justifyContent: open ? 'initial' : 'center',
                    px: 2.5,
                  }}

                >
                  {path ===
                    props.history.location.pathname ?
                    <ListItemIcon
                      sx={{
                        minWidth: 0,
                        mr: open ? 3 : 'auto',
                        justifyContent: 'center',
                        color: "#fff",
                      }}
                    >
                      {
                        title == "Users" ? <PersonIcon /> : <ContactsIcon />
                      }
                      {/* <img
                      src={title === "Users" ? path ===
                        props.history.location.pathname ? userIconActive : userIcon : path ===
                          props.history.location.pathname ? contactsIconActive : contactsIcon}
                      alt=""
                      width={"20px"}
                    /> */}
                    </ListItemIcon> :
                    <ListItemIcon
                      sx={{
                        minWidth: 0,
                        mr: open ? 3 : 'auto',
                        justifyContent: 'center',
                        ...iconColor
                      }}
                    >
                      {
                        title == "Users" ? <PersonIcon /> : <ContactsIcon />
                      }
                      {/* <img
                         src={title === "Users" ? path ===
                           props.history.location.pathname ? userIconActive : userIcon : path ===
                             props.history.location.pathname ? contactsIconActive : contactsIcon}
                         alt=""
                         width={"20px"}
                       /> */}
                    </ListItemIcon>
                  }
                  <ListItemText primary={title} sx={{ opacity: open ? 1 : 0 }} />
                </ListItemButton>
                {!open ? <span style={{ marginLeft: title === "Users" ? "10px" : "" }}>{title}</span> : ''}
              </ListItem>
            )
          }
          {
            (user.profile === "Admin") && (user.bannerRole===true) &&
            <ListItem disablePadding sx={{ display: 'block' }}
            style={{
              backgroundColor: "/banerManagement" ===
                props.history.location.pathname ? "#279f9f" : appTheme ? themeColors.sidebarBackgroundColor : themeColors.sidebarBackgroundColorDark,
              color: "/banerManagement" ===
                props.history.location.pathname ? "#FFFFFF" : "", cursor: "pointer"
            }}
            onClick={() => {
              googleAnalyticsTabClick("Analytics_Tab",user)
              props.history.push("/banerManagement");
            }}
          >
            <ListItemButton
              sx={{
                minHeight: 48,
                justifyContent: open ? 'initial' : 'center',
                px: 2.5,
              }}

            >
              {props.history.location.pathname === "/banerManagement" ?
                <ListItemIcon
                  sx={{
                    minWidth: 0,
                    mr: open ? 3 : 'auto',
                    justifyContent: 'center',
                    color: "#fff"
                  }}
                >
                  <ViewCarouselIcon />
                  {/* <img
                src={"/banerManagement" ===
                  props.history.location.pathname ? activeAnalyticsIcon : analyticsIcon}
                alt=""
                width={"20px"}
              /> */}
                </ListItemIcon> :
                <ListItemIcon
                  sx={{
                    minWidth: 0,
                    mr: open ? 3 : 'auto',
                    justifyContent: 'center',
                    ...iconColor
                  }}
                >
                  <ViewCarouselIcon />
                </ListItemIcon>
              }

              <ListItemText primary={"Banner Mgmt"}
                sx={{ opacity: open ? 1 : 0 }} />
            </ListItemButton>
            {!open ? <span>BM</span> : ''}
          </ListItem>

          }

          


          {
            (user.profile === "Admin") &&
              (
                <>
                  <ListItem disablePadding sx={{ display: 'block' }}
                    style={{
                      backgroundColor: "/userManagement" === props.history.location.pathname ? "#279f9f" : appTheme ? themeColors.sidebarBackgroundColor : themeColors.sidebarBackgroundColorDark,
                      color: "/userManagement" ===
                        props.history.location.pathname ? "#FFFFFF" : "", cursor: "pointer"
                    }}
                    onClick={() => {
                      googleAnalyticsTabClick("Users_Tab",user)
                      props.history.push("/userManagement");
                    }}
                  >
                    <ListItemButton
                      sx={{
                        minHeight: 48,
                        justifyContent: open ? 'initial' : 'center',
                        px: 2.5,
                      }}

                    >
                      {"/userManagement" ===
                        props.history.location.pathname ?
                        <ListItemIcon
                          sx={{
                            minWidth: 0,
                            mr: open ? 3 : 'auto',
                            justifyContent: 'center',
                            color: "#fff",
                          }}
                        >
                          <PersonIcon />
                          {/* <img
                        src={title === "Users" ? path ===
                          props.history.location.pathname ? userIconActive : userIcon : path ===
                            props.history.location.pathname ? contactsIconActive : contactsIcon}
                        alt=""
                        width={"20px"}
                      /> */}
                        </ListItemIcon> :
                        <ListItemIcon
                          sx={{
                            minWidth: 0,
                            mr: open ? 3 : 'auto',
                            justifyContent: 'center',
                            ...iconColor
                          }}
                        >
                          <PersonIcon />
                          {/* <img
                           src={title === "Users" ? path ===
                             props.history.location.pathname ? userIconActive : userIcon : path ===
                               props.history.location.pathname ? contactsIconActive : contactsIcon}
                           alt=""
                           width={"20px"}
                         /> */}
                        </ListItemIcon>
                      }
                      <ListItemText primary={"Users"} sx={{ opacity: open ? 1 : 0 }} />
                    </ListItemButton>
                    {!open ? <span style={{ marginLeft: title === "Users" ? "10px" : "" }}>{title}</span> : ''}
                  </ListItem>

                  <ListItem disablePadding sx={{ display: 'block' }}
                    style={{
                      backgroundColor: api === props.history.location.pathname ? "#279f9f" : appTheme ? themeColors.sidebarBackgroundColor : themeColors.sidebarBackgroundColorDark,
                      color: api ===
                        props.history.location.pathname ? "#FFFFFF" : "", cursor: 'pointer'
                    }}
                    onClick={() => {
                      googleAnalyticsTabClick("API_Tokens_Tab",user)
                      props.history.push(api);
                    }}
                  >
                    <ListItemButton
                      sx={{
                        minHeight: 48,
                        justifyContent: open ? 'initial' : 'center',
                        px: 2.5,
                      }}
                    >
                      {api === props.history.location.pathname ? <ListItemIcon
                        sx={{
                          minWidth: 0,
                          mr: open ? 3 : 'auto',
                          justifyContent: 'center',
                          color: "#fff"
                        }}
                      >
                        <CloudUploadIcon />
                      </ListItemIcon> : <ListItemIcon
                        sx={{
                          minWidth: 0,
                          mr: open ? 3 : 'auto',
                          justifyContent: 'center',
                          ...iconColor
                        }}
                      >
                        <CloudUploadIcon />
                      </ListItemIcon>}
                      <ListItemText primary={"API Tokens"} sx={{ opacity: open ? 1 : 0 }} />
                    </ListItemButton>
                    {!open ? <span style={{ marginLeft: "18px" }}>API Tokens</span> : ''}
                  </ListItem>

                  <ListItem disablePadding sx={{ display: 'block' }}
                    style={{
                      backgroundColor: news === props.history.location.pathname ? "#279f9f" : appTheme ? themeColors.sidebarBackgroundColor : themeColors.sidebarBackgroundColorDark,
                      color: news ===
                        props.history.location.pathname ? "#FFFFFF" : "", cursor: "pointer"
                    }}
                    onClick={() => {
                      googleAnalyticsTabClick("Admin_News_Tab",user)
                      props.history.push(news);
                    }}
                  >
                    <ListItemButton
                      sx={{
                        minHeight: 48,
                        justifyContent: open ? 'initial' : 'center',
                        px: 2.5,
                      }}

                    >
                      {news === props.history.location.pathname ? <ListItemIcon
                        sx={{
                          minWidth: 0,
                          mr: open ? 3 : 'auto',
                          justifyContent: 'center',
                          color: "#fff"
                        }}
                      >
                        <NewspaperIcon />
                      </ListItemIcon> :
                        <ListItemIcon
                          sx={{
                            minWidth: 0,
                            mr: open ? 3 : 'auto',
                            justifyContent: 'center',
                            ...iconColor
                          }}
                        >
                          <NewspaperIcon />
                        </ListItemIcon>}
                      <ListItemText primary={"NEWS"} sx={{ opacity: open ? 1 : 0 }} />
                    </ListItemButton>
                    {!open ? <span style={{ marginLeft: "10px" }}>NEWS</span> : ''}
                  </ListItem>

                  {/* <ListItem disablePadding sx={{ display: 'block' }}

                    style={{
                      backgroundColor: updatePassword ===
                        props.history.location.pathname ? "#279f9f" : appTheme ? themeColors.sidebarBackgroundColor : themeColors.sidebarBackgroundColorDark,
                      color: updatePassword ===
                        props.history.location.pathname ? "#FFFFFF" : "", cursor: "pointer"
                    }}
                    onClick={() => {
                      props.history.push(updatePassword);
                    }}
                  >
                    <ListItemButton
                      sx={{
                        minHeight: 48,
                        justifyContent: open ? 'initial' : 'center',
                        px: 2.5,
                      }}

                    >
                      {updatePassword ===
                        props.history.location.pathname ?
                        <ListItemIcon
                          sx={{
                            minWidth: 0,
                            mr: open ? 3 : 'auto',
                            justifyContent: 'center',
                            color: "#fff"
                          }}
                        >
                          <PasswordIcon />
                        </ListItemIcon> :
                        <ListItemIcon
                          sx={{
                            minWidth: 0,
                            mr: open ? 3 : 'auto',
                            justifyContent: 'center',
                            ...iconColor
                          }}
                        >
                          <PasswordIcon />
                        </ListItemIcon>
                      }
                      <ListItemText primary={"Update Password"} sx={{ opacity: open ? 1 : 0 }} />
                    </ListItemButton>
                    {!open ? <span>Update P.</span> : ''}
                  </ListItem> */}
                  
                  <ListItem disablePadding sx={{ display: 'block' }}

                    style={{
                      backgroundColor: "/organsationSettting" ===
                        props.history.location.pathname ? "#279f9f" : appTheme ? themeColors.sidebarBackgroundColor : themeColors.sidebarBackgroundColorDark,
                      color:  "/organsationSettting" ===
                        props.history.location.pathname ? "#FFFFFF" : "", cursor: "pointer"
                    }}
                    onClick={() => {
                      googleAnalyticsTabClick("Admin_Settings_Tab",user)
                      props.history.push("/organsationSettting");
                    }}
                  >
                    <ListItemButton
                      sx={{
                        minHeight: 48,
                        justifyContent: open ? 'initial' : 'center',
                        px: 2.5,
                      }}

                    >
                      { "/organsationSettting" ===
                        props.history.location.pathname ?
                        <ListItemIcon
                          sx={{
                            minWidth: 0,
                            mr: open ? 3 : 'auto',
                            justifyContent: 'center',
                            color: "#fff"
                          }}
                        >
                          <SettingsIcon />
                        </ListItemIcon> :
                        <ListItemIcon
                          sx={{
                            minWidth: 0,
                            mr: open ? 3 : 'auto',
                            justifyContent: 'center',
                            ...iconColor
                          }}
                        >
                          <SettingsIcon />
                        </ListItemIcon>
                      }
                      <ListItemText primary={"Admin Settings"} sx={{ opacity: open ? 1 : 0 }} />
                    </ListItemButton>
                    {!open ? <span>Admin Settings</span> : ''}
                  </ListItem>
                </>
              ) 

          }

          {(user.profile == "Admin" || user.profile == "Lead Manager" || user.profile == "Team Lead" || user.profile == "Sales") && (
            <>
            <ListItem disablePadding sx={{ display: 'block' }}
              style={{
                backgroundColor: "/analytics" ===
                  props.history.location.pathname ? "#279f9f" : appTheme ? themeColors.sidebarBackgroundColor : themeColors.sidebarBackgroundColorDark,
                color: "/analytics" ===
                  props.history.location.pathname ? "#FFFFFF" : "", cursor: "pointer"
              }}
              onClick={() => {
                googleAnalyticsTabClick("Analytics_Tab",user)
                props.history.push("/analytics");
              }}
            >
              <ListItemButton
                sx={{
                  minHeight: 48,
                  justifyContent: open ? 'initial' : 'center',
                  px: 2.5,
                }}

              >
                {props.history.location.pathname === "/analytics" ?
                  <ListItemIcon
                    sx={{
                      minWidth: 0,
                      mr: open ? 3 : 'auto',
                      justifyContent: 'center',
                      color: "#fff"
                    }}
                  >
                    <AnalyticsIcon />
                    {/* <img
                  src={"/analytics" ===
                    props.history.location.pathname ? activeAnalyticsIcon : analyticsIcon}
                  alt=""
                  width={"20px"}
                /> */}
                  </ListItemIcon> :
                  <ListItemIcon
                    sx={{
                      minWidth: 0,
                      mr: open ? 3 : 'auto',
                      justifyContent: 'center',
                      ...iconColor
                    }}
                  >
                    <AnalyticsIcon />
                  </ListItemIcon>
                }

                <ListItemText primary={"Analytics"}
                  sx={{ opacity: open ? 1 : 0 }} />
              </ListItemButton>
              {!open ? <span>Analytics</span> : ''}
            </ListItem>
                      <ListItem disablePadding sx={{ display: 'block' }}
                      style={{
                        backgroundColor: "/contacts" === props.history.location.pathname ? "#279f9f" : appTheme ? themeColors.sidebarBackgroundColor : themeColors.sidebarBackgroundColorDark,
                        color: "/contacts" ===
                          props.history.location.pathname ? "#FFFFFF" : "", cursor: "pointer"
                      }}
                      onClick={() => {
                        googleAnalyticsTabClick("Contacts_Tab",user)
                        props.history.push("/contacts");
                      }}
                    >
                      <ListItemButton
                        sx={{
                          minHeight: 48,
                          justifyContent: open ? 'initial' : 'center',
                          px: 2.5,
                        }}
          
                      >
                        {"/contacts" ===
                          props.history.location.pathname ?
                          <ListItemIcon
                            sx={{
                              minWidth: 0,
                              mr: open ? 3 : 'auto',
                              justifyContent: 'center',
                              color: "#fff",
                            }}
                          >
                            <ContactsIcon />
                            {/* {
                                    title == "Users" ? <PersonIcon /> : <ContactsIcon />
                                  } */}
                          </ListItemIcon> :
                          <ListItemIcon
                            sx={{
                              minWidth: 0,
                              mr: open ? 3 : 'auto',
                              justifyContent: 'center',
                              ...iconColor
                            }}
                          >
                            <ContactsIcon />
                            {/* {
                                    title == "Users" ? <PersonIcon /> : <ContactsIcon />
                                  } */}
                          </ListItemIcon>
                        }
                        <ListItemText primary={"Contacts"} sx={{ opacity: open ? 1 : 0 }} />
                      </ListItemButton>
                      {!open ? <span>{"Contacts"}</span> : ''}
                    </ListItem>
            </>
          )

          }

{userOid && (<>
                     <ListItem disablePadding sx={{ display: 'block' }}
                     style={{
                       backgroundColor: mmb === props.history.location.pathname ? "#279f9f" : appTheme ? themeColors.sidebarBackgroundColor:themeColors.sidebarBackgroundColorDark,
                       color: mmb ===
                         props.history.location.pathname ? "#FFFFFF" : "", cursor: "pointer"
                     }}
                     onClick={() => {
                      googleAnalyticsMMBTabClick("My Magic Box Tab click","MY MAGIC BOX",user)
                       window.open(autoToken, "_blank")
                     }}
                   >
                     <ListItemButton
                       sx={{
                         minHeight: 48,
                         justifyContent: open ? 'initial' : 'center',
                         px: 2.5,
                       }}
                     >
                            <ListItemIcon
                            sx={{
                              minWidth: 0,
                              mr: open ? 3 : 'auto',
                              justifyContent: 'center',
                              ...iconColor
                            }}
                          >
                             {/* <TaskIcon /> */}
                             <h6 style={{ color: "red", paddingTop: "7px", fontWeight: "bold" }}>mb</h6>

                          </ListItemIcon>
                       
                         <ListItemText primary={"My Magic Box"} sx={{ opacity: open ? 1 : 0 }} />
                         {open && <div style={{backgroundColor:"#ffc61a",fontSize:"10px",padding:"2px 5px 2px 5px",margin:"0 0 0 95px",borderRadius:"4px"}}>NEW</div>}
                       </ListItemButton>
                       {!open ? <span style={{ marginLeft: "10px" }}>MMB</span> : ''}
                     </ListItem>
                     <ListItem disablePadding sx={{ display: 'block' }}
                     style={{
                        backgroundColor: "/response" === props.history.location.pathname ? "#279f9f" : appTheme ? themeColors.sidebarBackgroundColor : themeColors.sidebarBackgroundColorDark,
                        color: "/response" ===
                          props.history.location.pathname ? "#FFFFFF" : "", cursor: "pointer"
                      }}
                     onClick={() => {
                      //  window.open(autoToken, "_blank")
                      googleAnalyticsTabClick("Response Tab Click",user)
                      props.history.push("/response");
                     }}
                   >
                     <ListItemButton
                       sx={{
                         minHeight: 48,
                         justifyContent: open ? 'initial' : 'center',
                         px: 2.5,
                       }}
                     >
                            <ListItemIcon
                            sx={{
                              minWidth: 0,
                              mr: open ? 3 : 'auto',
                              justifyContent: 'center',
                              ...iconColor
                            }}
                          >
                             {/* <TaskIcon /> */}
                             <h6 style={{ color: "red", paddingTop: "7px", fontWeight: "bold" }}>mb</h6>

                          </ListItemIcon>
                       
                         <ListItemText primary={"Response"} sx={{ opacity: open ? 1 : 0 }} />
                         {open && <div style={{backgroundColor:"#ffc61a",fontSize:"10px",padding:"2px 5px 2px 5px",margin:"0 0 0 95px",borderRadius:"4px"}}>NEW</div>}
                       </ListItemButton>
                       {!open ? <span style={{ marginLeft: "10px" }}>MMB</span> : ''}
                     </ListItem>
                     
                     </>     
          )}

          {
            (user.profile === "Admin" && userOid && accessAllowedMarketingAutomation) && (
              <ListItem disablePadding sx={{ display: 'block' }}
                style={{
                  backgroundColor: "/marketing" ===
                    props.history.location.pathname ? "#279f9f" : appTheme ? themeColors.sidebarBackgroundColor : themeColors.sidebarBackgroundColorDark,
                  color: "/marketing" ===
                    props.history.location.pathname ? "#FFFFFF" : "", cursor: "pointer"
                }}
                onClick={() => {
                  // googleAnalyticsTabClick("Subscription_Tab", user)
                  googleAnalyticsTabClick("Marketing_Tab",user)
                  props.history.push("/marketing");
                }}
              >
                <ListItemButton
                  sx={{
                    minHeight: 48,
                    justifyContent: open ? 'initial' : 'center',
                    px: 2.5,
                  }}
                >
                  {/* {"/marketing" ===
                        props.history.location.pathname ?
                        <ListItemIcon
                          sx={{
                            minWidth: 0,
                            mr: open ? 3 : 'auto',
                            justifyContent: 'center',
                            color: "#fff"
                          }}
                        >
                          <PaymentIcon />
                        </ListItemIcon>
                        :
                        <ListItemIcon
                          sx={{
                            minWidth: 0,
                            mr: open ? 3 : 'auto',
                            justifyContent: 'center',
                            ...iconColor
                          }}
                        >
                          <PaymentIcon />
                        </ListItemIcon>
                      } */}
                  <div style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
                    {
                      "/marketing" ===
                        props.history.location.pathname ?
                        <img src={BroadcastWhite} className="broadcastImg" alt="Marketing Tab" /> :
                        <img src={Broadcast} className="broadcastImg" alt="Marketing Tab" />
                    }
                    <ListItemText primary={"Marketing"} sx={{ opacity: open ? 1 : 0 }} />
                    <img src={NewLabel} className="newLabelImg" alt="Marketing Tab" />
                  </div>
                </ListItemButton>
                {!open ? <span>Mark...</span> : ''}
              </ListItem>
            )
          }

          {
            
            (user.profile === "Admin" && userOid && ((hasActiveWAPackage && WAAgentActiveStatus=="Active") ||  user.adminTemplateRole)) && (
            // (user.profile === "Admin" && userOid && user.adminTemplateRole) && (
              <ListItem disablePadding sx={{ display: 'block' }}
                style={{
                  backgroundColor: "/whatsapptemplates" ===
                    props.history.location.pathname ? "#279f9f" : appTheme ? themeColors.sidebarBackgroundColor : themeColors.sidebarBackgroundColorDark,
                  color: "/whatsapptemplates" ===
                    props.history.location.pathname ? "#FFFFFF" : "", cursor: "pointer"
                }}
                onClick={() => {
                  // googleAnalyticsTabClick("Subscription_Tab", user)
                  // googleAnalyticsTabClick("Marketing_Tab", user)
                  props.history.push("/whatsapptemplates");
                }}
              >
                <ListItemButton
                  sx={{
                    minHeight: 48,
                    justifyContent: open ? 'initial' : 'center',
                    px: 2.5,
                  }}
                >
                  {"/whatsapptemplates" ===
                        props.history.location.pathname ?
                        <ListItemIcon
                          sx={{
                            minWidth: 0,
                            mr: open ? 3 : 'auto',
                            justifyContent: 'center',
                            color: "#fff"
                          }}
                        >
                          <PostAddOutlinedIcon />
                        </ListItemIcon>
                        :
                        <ListItemIcon
                          sx={{
                            minWidth: 0,
                            mr: open ? 3 : 'auto',
                            justifyContent: 'center',
                            ...iconColor
                          }}
                        >
                          <PostAddOutlinedIcon />
                        </ListItemIcon>
                      }
                   <ListItemText primary={"Templates"} sx={{ opacity: open ? 1 : 0 }} />
                </ListItemButton>
                {!open ? <span>Templates</span> : ''}
              </ListItem>
            )
          }

          {(user.profile === "Admin" && showReportTab) &&
                <ListItem disablePadding sx={{ display: 'block' }}
                  style={{
                    backgroundColor: "/leadquality" ===
                      props.history.location.pathname ? "#279f9f" : appTheme ? themeColors.sidebarBackgroundColor : themeColors.sidebarBackgroundColorDark,
                    color: "/leadquality" ===
                      props.history.location.pathname ? "#FFFFFF" : "", cursor: "pointer"
                  }}
                  onClick={() => {
                    props.history.push("/leadquality");
                  }}
                >
                  <ListItemButton
                    sx={{
                      minHeight: 48,
                      justifyContent: open ? 'initial' : 'center',
                      px: 2.5,
                    }}
                  >
                    {"/leadquality" ===
                      props.history.location.pathname ?
                      <ListItemIcon
                        sx={{
                          minWidth: 0,
                          mr: open ? 3 : 'auto',
                          justifyContent: 'center',
                          color: "#fff"
                        }}
                      >
                        {/* <PaymentIcon /> */}
                        <img src={ReportWhiteIcon} alt="icon"/>
                      </ListItemIcon>
                      :
                      <ListItemIcon
                        sx={{
                          minWidth: 0,
                          mr: open ? 3 : 'auto',
                          justifyContent: 'center',
                          ...iconColor
                        }}
                      >
                        {/* <PaymentIcon /> */}
                        <img src={ReportBlackIcon} alt="icon"/>
                      </ListItemIcon>
                    }
                    <div style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
                    <ListItemText primary={"Report"} sx={{ opacity: open ? 1 : 0 }} />
                    <img src={NewLabel} className="newLabelImg" alt="Report Tab" />
                    </div>
                  </ListItemButton>
                  {!open ? <span>Report</span> : ''}
                </ListItem>
              }

{/*           
          <ListItem disablePadding sx={{ display: 'block' }}
            style={{
              backgroundColor: path === props.history.location.pathname ? "#279f9f" : appTheme ? themeColors.sidebarBackgroundColor:themeColors.sidebarBackgroundColorDark,
              color: path ===
                props.history.location.pathname ? "#FFFFFF" : "", cursor: "pointer"
            }}
            onClick={() => {
              title == "Users" ? googleAnalyticsTabClick("Users_Tab",user) : googleAnalyticsTabClick("Contacts_Tab",user)
              props.history.push(path);
            }}
          >
            <ListItemButton
              sx={{
                minHeight: 48,
                justifyContent: open ? 'initial' : 'center',
                px: 2.5,
              }}

            >
              {path ===
                props.history.location.pathname ?
                <ListItemIcon
                  sx={{
                    minWidth: 0,
                    mr: open ? 3 : 'auto',
                    justifyContent: 'center',
                    color: "#fff",
                  }}
                >
                  {
                    title == "Users" ? <PersonIcon /> : <ContactsIcon />
                  }
                </ListItemIcon> :
                <ListItemIcon
                  sx={{
                    minWidth: 0,
                    mr: open ? 3 : 'auto',
                    justifyContent: 'center',
                    ...iconColor
                  }}
                >
                  {
                    title == "Users" ? <PersonIcon /> : <ContactsIcon />
                  }
                </ListItemIcon>
              }
              <ListItemText primary={title} sx={{ opacity: open ? 1 : 0 }} />
            </ListItemButton>
            {!open ? <span style={{ marginLeft: title === "Users" ? "10px" : "" }}>{title}</span> : ''}
          </ListItem> */}
        
          {title !== "Drilldown" &&
            (user.profile === "Lead Manager" ||
              user.profile === "Admin" ||
              user.profile === "Sales" ||
              user.profile === "Team Lead") && (
              <>

              <ListItem disablePadding sx={{ display: 'block' }}
                style={{
                  backgroundColor: "/tasks" === props.history.location.pathname ? "#279f9f" : appTheme ? themeColors.sidebarBackgroundColor:themeColors.sidebarBackgroundColorDark,
                  color: "/tasks" ===
                    props.history.location.pathname ? "#FFFFFF" : "", cursor: "pointer"
                }}
                onClick={() => {
                  googleAnalyticsTabClick("Tasks_Tab",user)
                  props.history.push("/tasks");
                }}
              >
                <ListItemButton
                  sx={{
                    minHeight: 48,
                    justifyContent: open ? 'initial' : 'center',
                    px: 2.5,
                  }}
                >
                        {"/tasks" ===
                    props.history.location.pathname ?
                    <ListItemIcon
                    sx={{
                      minWidth: 0,
                      mr: open ? 3 : 'auto',
                      justifyContent: 'center',
                      color:"#fff",
                    }}
                  >
                    <TaskIcon />
                  </ListItemIcon>:
                       <ListItemIcon
                       sx={{
                         minWidth: 0,
                         mr: open ? 3 : 'auto',
                         justifyContent: 'center',
                         ...iconColor
                       }}
                     >
                        <TaskIcon />
                     </ListItemIcon>
                  } 
                    <ListItemText primary={"Tasks"} sx={{ opacity: open ? 1 : 0 }} />
                  </ListItemButton>
                  {!open ? <span style={{ marginLeft: "10px" }}>Tasks</span> : ''}
                </ListItem>
                {(!organizationData.business_domain || organizationData.business_domain== "Real Estate")&&
                 <ListItem disablePadding sx={{ display: 'block' }}
                style={{
                  backgroundColor: "/booking" ===
                    props.history.location.pathname ? "#279f9f" : appTheme ? themeColors.sidebarBackgroundColor:themeColors.sidebarBackgroundColorDark,
                  color: "/booking" ===
                    props.history.location.pathname ? "white" : "", cursor: "pointer"
                }}
                onClick={() => {
                  googleAnalyticsTabClick("Booking_Tab",user)
                  props.history.push("/booking");
                }}
              >
                <ListItemButton
                  sx={{
                    minHeight: 48,
                    justifyContent: open ? 'initial' : 'center',
                    px: 2.5,
                  }}
                >
                  {"/booking" ===
                        props.history.location.pathname ? 
                        <ListItemIcon
                        sx={{
                          minWidth: 0,
                          mr: open ? 3 : 'auto',
                          justifyContent: 'center',
                          color:"#fff"
                        }}
                      >
                        <ListAltIcon />
                      </ListItemIcon>
                        : 
                        <ListItemIcon
                        sx={{
                          minWidth: 0,
                          mr: open ? 3 : 'auto',
                          justifyContent: 'center',
                          ...iconColor
                        }}
                      >
                        <ListAltIcon />
                      </ListItemIcon>
                        }
                  <ListItemText primary={"Bookings"} sx={{ opacity: open ? 1 : 0 }} />
                </ListItemButton>
                {!open ? <span style={{ marginLeft: "5px" }}>Bookings</span> : ''}
              </ListItem>}
              {/* -------------------------------------ReEnquired Leads Panel------------------------------------------------------------- */}
              {/* <ListItem disablePadding sx={{ display: 'block' }}
                onClick={() => {
                  props.history.push("/reenquiredLeads");
                }}
                style={{
                  backgroundColor: "/reenquiredLeads" ===
                    props.history.location.pathname ? "#279f9f" : appTheme ? themeColors.sidebarBackgroundColor:themeColors.sidebarBackgroundColorDark,
                  color: "/reenquiredLeads" ===
                    props.history.location.pathname ? "#FFFFFF" : "", cursor: "pointer"
                }}
              >
                <ListItemButton
                  sx={{
                    minHeight: 48,
                    justifyContent: open ? 'initial' : 'center',
                    px: 2.5,
                  }}
                >
                  {"/reenquiredLeads" ===
                        props.history.location.pathname ?                   <ListItemIcon
                        sx={{
                          minWidth: 0,
                          mr: open ? 3 : 'auto',
                          justifyContent: 'center',
                         color:"#fff"
                        }}
                      >
                        <LeadList />
                      </ListItemIcon> :                   <ListItemIcon
                    sx={{
                      minWidth: 0,
                      mr: open ? 3 : 'auto',
                      justifyContent: 'center',
                      ...iconColor
                    }}
                  >
                    <LeadList />
                  </ListItemIcon>}
                  <ListItemText primary={"ReEnquired Leads"} sx={{ opacity: open ? 1 : 0 }} />
                </ListItemButton>
                {!open ? <span>ReEnqu..</span> : ''}
              </ListItem> */}
              {/* ------------------------------------------------------------------------------------------------------------------------ */}
              </>
            )}
          {title !== "Drilldown" && (
            user.profile === "Lead Manager" ||
            user.profile === "Admin"
          )&& (
            <>
              <ListItem disablePadding sx={{ display: 'block' }}
                style={{
                  backgroundColor: "/projects" ===
                    props.history.location.pathname ? "#279f9f" : appTheme ? themeColors.sidebarBackgroundColor:themeColors.sidebarBackgroundColorDark,
                  color: "/projects" ===
                    props.history.location.pathname ? "white" : "", cursor: "pointer"
                }}
                onClick={() => {
                  googleAnalyticsTabClick("Listings_Tab",user)
                  props.history.push("/projects");
                }}
              >
                <ListItemButton
                  sx={{
                    minHeight: 48,
                    justifyContent: open ? 'initial' : 'center',
                    px: 2.5,
                  }}
                >
                  {"/projects" ===
                        props.history.location.pathname ? 
                        <ListItemIcon
                        sx={{
                          minWidth: 0,
                          mr: open ? 3 : 'auto',
                          justifyContent: 'center',
                          color:"#fff"
                        }}
                      >
                        <ApartmentIcon />
                      </ListItemIcon>
                        : 
                        <ListItemIcon
                        sx={{
                          minWidth: 0,
                          mr: open ? 3 : 'auto',
                          justifyContent: 'center',
                          ...iconColor
                        }}
                      >
                          <ApartmentIcon />
                      </ListItemIcon>
                        }
                  <ListItemText primary={"Listings"} sx={{ opacity: open ? 1 : 0 }} />
                </ListItemButton>
                {!open ? <span style={{ marginLeft: "5px" }}>Listings</span> : ''}
              </ListItem>
              <ListItem disablePadding sx={{ display: 'block' }}
                style={{
                  backgroundColor: "/resources" ===
                    props.history.location.pathname ? "#279f9f" : appTheme ? themeColors.sidebarBackgroundColor:themeColors.sidebarBackgroundColorDark,
                  color: "/resources" ===
                    props.history.location.pathname ? "#FFFFFF" : "", cursor: "pointer"
                }}
                onClick={() => {
                  googleAnalyticsTabClick("Resources_Tab",user)
                  props.history.push("/resources");
                }}
              >
                <ListItemButton
                  sx={{
                    minHeight: 48,
                    justifyContent: open ? 'initial' : 'center',
                    px: 2.5,
                  }}
                >
                  {"/resources" ===
                        props.history.location.pathname ? 
                        <ListItemIcon
                        sx={{
                          minWidth: 0,
                          mr: open ? 3 : 'auto',
                          justifyContent: 'center',
                          color:"#fff"
                        }}
                      >
                        <LanguageIcon />
                      </ListItemIcon>
                        : 
                        <ListItemIcon
                        sx={{
                          minWidth: 0,
                          mr: open ? 3 : 'auto',
                          justifyContent: 'center',
                          ...iconColor
                        }}
                      >
                        <LanguageIcon />
                      </ListItemIcon>
                        }
                  <ListItemText primary={"Resources"} sx={{ opacity: open ? 1 : 0 }} />
                </ListItemButton>
                {!open ? <span>Resourc..</span> : ''}
              </ListItem>


              {userPreference.show_subscription_panel === true && 
              <ListItem disablePadding sx={{ display: 'block' }}
              style={{
                backgroundColor: "/subscriptionDetails" ===
                  props.history.location.pathname ? "#279f9f" : appTheme ? themeColors.sidebarBackgroundColor:themeColors.sidebarBackgroundColorDark,
                color: "/subscriptionDetails" ===
                  props.history.location.pathname ? "#FFFFFF" : "", cursor: "pointer"
              }}
              onClick={() => {
                googleAnalyticsTabClick("Subscription_Tab",user)
                props.history.push("/subscriptionDetails");
              }}
            >
              <ListItemButton
                sx={{
                  minHeight: 48,
                  justifyContent: open ? 'initial' : 'center',
                  px: 2.5,
                }}
              >
                {"/subscriptionDetails" ===
                      props.history.location.pathname ? 
                      <ListItemIcon
                      sx={{
                        minWidth: 0,
                        mr: open ? 3 : 'auto',
                        justifyContent: 'center',
                        color:"#fff"
                      }}
                    >
                      <PaymentIcon />
                    </ListItemIcon>
                      : 
                      <ListItemIcon
                      sx={{
                        minWidth: 0,
                        mr: open ? 3 : 'auto',
                        justifyContent: 'center',
                        ...iconColor
                      }}
                    >
                      <PaymentIcon />
                    </ListItemIcon>
                      }
                <ListItemText primary={"Subscription"} sx={{ opacity: open ? 1 : 0 }} />
              </ListItemButton>
              {!open ? <span>Subscr...</span> : ''}
            </ListItem>
              }

              
              <ListItem disablePadding sx={{ display: 'block' }}
                style={{
                  backgroundColor: "/Settings" ===
                    props.history.location.pathname ? "#279f9f" : appTheme ? themeColors.sidebarBackgroundColor:themeColors.sidebarBackgroundColorDark,
                  color: "/Settings" ===
                    props.history.location.pathname ? "#FFFFFF" : "", cursor: "pointer"
                }}
                onClick={() => {
                  googleAnalyticsTabClick("Settings_Tab",user)
                  props.history.push("/Settings");
                }}
              >
                <ListItemButton
                  sx={{
                    minHeight: 48,
                    justifyContent: open ? 'initial' : 'center',
                    px: 2.5,
                  }}
                >
                  {"/Settings" ===
                        props.history.location.pathname ? 
                        <ListItemIcon
                        sx={{
                          minWidth: 0,
                          mr: open ? 3 : 'auto',
                          justifyContent: 'center',
                          color:"#fff"
                        }}
                      >
                        <SettingsIcon />
                      </ListItemIcon>
                        : 
                        <ListItemIcon
                        sx={{
                          minWidth: 0,
                          mr: open ? 3 : 'auto',
                          justifyContent: 'center',
                          ...iconColor
                        }}
                      >
                        <SettingsIcon />
                      </ListItemIcon>
                        }
                  <ListItemText primary={"Settings"} sx={{ opacity: open ? 1 : 0 }} />
                </ListItemButton>
                {!open ? <span>Setti...</span> : ''}
              </ListItem>

              <ListItem disablePadding sx={{ display: 'block' }}
                style={{
                  backgroundColor: "/callLogs" ===
                    props.history.location.pathname ? "#279f9f" : appTheme ? themeColors.sidebarBackgroundColor:themeColors.sidebarBackgroundColorDark,
                  color: "/callLogs" ===
                    props.history.location.pathname ? "#FFFFFF" : "", cursor: "pointer"
                }}
                onClick={() => {
                  googleAnalyticsTabClick("CallLog_Tab",user)
                  props.history.push("/callLogs");
                }}
              >
                <ListItemButton
                  sx={{
                    minHeight: 48,
                    justifyContent: open ? 'initial' : 'center',
                    px: 2.5,
                  }}
                >
                  {"/callLogs" ===
                        props.history.location.pathname ? 
                        <ListItemIcon
                        sx={{
                          minWidth: 0,
                          mr: open ? 3 : 'auto',
                          justifyContent: 'center',
                         color:"#fff",
                        }}
                      >
                        <PhoneIcon />
                      </ListItemIcon>
                        : 
                        <ListItemIcon
                        sx={{
                          minWidth: 0,
                          mr: open ? 3 : 'auto',
                          justifyContent: 'center',
                          ...iconColor
                        }}
                      >
                        <PhoneIcon />
                      </ListItemIcon>
                        }
                  <ListItemText primary={"Call Logs"} sx={{ opacity: open ? 1 : 0 }} />
                </ListItemButton>
                {!open ? <span>Call Logs</span> : ''}
              </ListItem>
              <ListItem disablePadding sx={{ display: 'block' }}
                style={{
                  backgroundColor: "/faqs" ===
                    props.history.location.pathname ? "#279f9f" : appTheme ? themeColors.sidebarBackgroundColor:themeColors.sidebarBackgroundColorDark,
                  color: "/faqs" ===
                    props.history.location.pathname ? "#FFFFFF" : "", cursor: 'pointer'
                }}
                onClick={() => {
                  googleAnalyticsTabClick("FAQ_Tab",user)
                  props.history.push("/faqs");
                }}
              >
                <ListItemButton
                  sx={{
                    minHeight: 48,
                    justifyContent: open ? 'initial' : 'center',
                    px: 2.5,
                  }}
                >
                  {"/faqs" ===
                        props.history.location.pathname ? 
                        <ListItemIcon
                        sx={{
                          minWidth: 0,
                          mr: open ? 3 : 'auto',
                          justifyContent: 'center',
                          color:"#fff"
                        }}
                      >
                        <LiveHelpIcon />
                      </ListItemIcon>
                        : 
                        <ListItemIcon
                        sx={{
                          minWidth: 0,
                          mr: open ? 3 : 'auto',
                          justifyContent: 'center',
                          ...iconColor
                        }}
                      >
                        <LiveHelpIcon />
                      </ListItemIcon>
                        }
                  <ListItemText primary={"FAQ"} sx={{ opacity: open ? 1 : 0 }} />
                </ListItemButton>
                {!open ? <span style={{ marginLeft: "17px" }}>FAQ</span> : ''}
              </ListItem>
              <ListItem disablePadding sx={{ display: 'block' }}
                style={{
                  backgroundColor: "/apiData" ===
                    props.history.location.pathname ? "#279f9f" : appTheme ? themeColors.sidebarBackgroundColor:themeColors.sidebarBackgroundColorDark,
                  color: "/apiData" ===
                    props.history.location.pathname ? "#FFFFFF" : "", cursor: "pointer"
                }}
                onClick={() => {
                  googleAnalyticsTabClick("API_Leads_Tab",user)
                  props.history.push("/apiData");
                }}
              >
                <ListItemButton
                  sx={{
                    minHeight: 48,
                    justifyContent: open ? 'initial' : 'center',
                    px: 2.5,
                  }}
                >
                  {"/apiData" ===
                        props.history.location.pathname ?                   <ListItemIcon
                        sx={{
                          minWidth: 0,
                          mr: open ? 3 : 'auto',
                          justifyContent: 'center',
                          color:"#fff"
                        }}
                      >
                        <CloudUploadIcon />
                      </ListItemIcon> :                   
                      <ListItemIcon
                    sx={{
                      minWidth: 0,
                      mr: open ? 3 : 'auto',
                      justifyContent: 'center',
                      ...iconColor
                    }}
                  >
                    <CloudUploadIcon />
                  </ListItemIcon>}
                  <ListItemText primary={"API"} sx={{ opacity: open ? 1 : 0 }} />
                </ListItemButton>
                {!open ? <span style={{ marginLeft: "18px" }}>API</span> : ''}
              </ListItem>

              <ListItem disablePadding sx={{ display: 'block' }}
                style={{
                  backgroundColor: "/integrations" ===
                    props.history.location.pathname ? "#279f9f" : appTheme ? themeColors.sidebarBackgroundColor:themeColors.sidebarBackgroundColorDark,
                  color: "/integrations" ===
                    props.history.location.pathname ? "#FFFFFF" : "", cursor: "pointer"
                }}
                onClick={() => {
                  googleAnalyticsTabClick("Integrations_Tab",user)
                  props.history.push("/integrations");
                }}
              >
                <ListItemButton
                  sx={{
                    minHeight: 48,
                    justifyContent: open ? 'initial' : 'center',
                    px: 2.5,
                  }}
                >
                  {"/integrations" ===
                        props.history.location.pathname ?                   <ListItemIcon
                        sx={{
                          minWidth: 0,
                          mr: open ? 3 : 'auto',
                          justifyContent: 'center',
                          color:"#fff"
                        }}
                      >
                        <CloudSyncIcon />
                      </ListItemIcon> :                   
                      <ListItemIcon
                    sx={{
                      minWidth: 0,
                      mr: open ? 3 : 'auto',
                      justifyContent: 'center',
                      ...iconColor
                    }}
                  >
                    <CloudSyncIcon />
                  </ListItemIcon>}
                  <ListItemText primary={"Integrations"} sx={{ opacity: open ? 1 : 0 }} />
                </ListItemButton>
                {!open ? <span style={{ marginLeft: "18px" }}>Integrations</span> : ''}
              </ListItem>
              {/* <ListItem disablePadding sx={{ display: 'block' }}
                style={{
                  backgroundColor: "/reenquiredLeads" ===
                    props.history.location.pathname ? "#279f9f" : appTheme ? themeColors.sidebarBackgroundColor:themeColors.sidebarBackgroundColorDark,
                  color: "/reenquiredLeads" ===
                    props.history.location.pathname ? "#FFFFFF" : "", cursor: "pointer"
                }}
                onClick={() => {
                  props.history.push("/reenquiredLeads");
                }}
              >
                <ListItemButton
                  sx={{
                    minHeight: 48,
                    justifyContent: open ? 'initial' : 'center',
                    px: 2.5,
                  }}
                >
                  {"/reenquiredLeads" ===
                        props.history.location.pathname ? 
                        <ListItemIcon
                        sx={{
                          minWidth: 0,
                          mr: open ? 3 : 'auto',
                          justifyContent: 'center',
                          color:"#fff"
                        }}
                      >
                        <CloudDownloadIcon />
                      </ListItemIcon>
                        : 
                        <ListItemIcon
                        sx={{
                          minWidth: 0,
                          mr: open ? 3 : 'auto',
                          justifyContent: 'center',
                          ...iconColor
                        }}
                      >
                        <CloudDownloadIcon />
                      </ListItemIcon>
                        }
                  <ListItemText primary={"ReEnquired Leads"} sx={{ opacity: open ? 1 : 0 }} />
                </ListItemButton>
                {!open ? <span>ReEnqui...</span> : ''}
              </ListItem> */}
              <ListItem disablePadding sx={{ display: 'block' }}
                onClick={() => {
                  googleAnalyticsTabClick("Lead_Distribution_Tab",user)
                  props.history.push("/leadDistributor");
                }}
                style={{
                  backgroundColor: "/leadDistributor" ===
                    props.history.location.pathname ? "#279f9f" : appTheme ? themeColors.sidebarBackgroundColor:themeColors.sidebarBackgroundColorDark,
                  color: "/leadDistributor" ===
                    props.history.location.pathname ? "#FFFFFF" : "", cursor: "pointer"
                }}
              >
                <ListItemButton
                  sx={{
                    minHeight: 48,
                    justifyContent: open ? 'initial' : 'center',
                    px: 2.5,
                  }}
                >
                  {"/leadDistributor" ===
                        props.history.location.pathname ?                   <ListItemIcon
                        sx={{
                          minWidth: 0,
                          mr: open ? 3 : 'auto',
                          justifyContent: 'center',
                         color:"#fff"
                        }}
                      >
                        <GroupsIcon />
                      </ListItemIcon> :                   <ListItemIcon
                    sx={{
                      minWidth: 0,
                      mr: open ? 3 : 'auto',
                      justifyContent: 'center',
                      ...iconColor
                    }}
                  >
                    <GroupsIcon />
                  </ListItemIcon>}
                  <ListItemText primary={"Lead Distribution"} sx={{ opacity: open ? 1 : 0 }} />
                </ListItemButton>
                {!open ? <span>Lead Dist..</span> : ''}
              </ListItem>
              <ListItem disablePadding sx={{ display: 'block' }}
                onClick={() => {
                  googleAnalyticsTabClick("Audit_Logs_Tab",user)
                  props.history.push("/auditLogs");
                }}
                style={{
                  backgroundColor: "/auditLogs" ===
                    props.history.location.pathname ? "#279f9f" : appTheme ? themeColors.sidebarBackgroundColor:themeColors.sidebarBackgroundColorDark,
                  color: "/auditLogs" ===
                    props.history.location.pathname ? "#FFFFFF" : "", cursor: "pointer"
                }}
              >
                <ListItemButton
                  sx={{
                    minHeight: 48,
                    justifyContent: open ? 'initial' : 'center',
                    px: 2.5,
                  }}
                >
                  {"/auditLogs" ===
                        props.history.location.pathname ?                   <ListItemIcon
                        sx={{
                          minWidth: 0,
                          mr: open ? 3 : 'auto',
                          justifyContent: 'center',
                         color:"#fff"
                        }}
                      >
                        <AuditLog />
                      </ListItemIcon> :                   <ListItemIcon
                    sx={{
                      minWidth: 0,
                      mr: open ? 3 : 'auto',
                      justifyContent: 'center',
                      ...iconColor
                    }}
                  >
                    <AuditLog />
                  </ListItemIcon>}
                  <ListItemText primary={"Audit Logs"} sx={{ opacity: open ? 1 : 0 }} />
                </ListItemButton>
                {!open ? <span>Audit..</span> : ''}
              </ListItem>
            </>
          )}

          {/* {customButton && (
            <ListItem disablePadding sx={{ display: 'block' }}

            style={{
              backgroundColor: customButton ===
                props.history.location.pathname ? "#279f9f" : appTheme ? themeColors.sidebarBackgroundColor:themeColors.sidebarBackgroundColorDark,
              color: customButton ===
                props.history.location.pathname ? "#FFFFFF" : "",cursor:"pointer"
            }}
            onClick={() => {
              props.history.push(customButton);
            }}
            >
              <ListItemButton
                sx={{
                  minHeight: 48,
                  justifyContent: open ? 'initial' : 'center',
                  px: 2.5,
                }}

              >
                {customButton ===
                      props.history.location.pathname ?                 
                      <ListItemIcon
                      sx={{
                        minWidth: 0,
                        mr: open ? 3 : 'auto',
                        justifyContent: 'center',
                        color:"#fff"
                      }}
                    >
                      <ToggleOnIcon />
                    </ListItemIcon> : 
                                    <ListItemIcon
                                    sx={{
                                      minWidth: 0,
                                      mr: open ? 3 : 'auto',
                                      justifyContent: 'center',
                                      ...iconColor
                                    }}
                                  >
                                    <ToggleOnIcon />
                                  </ListItemIcon>
                    }
                <ListItemText primary={"Custom Button"} sx={{ opacity: open ? 1 : 0 }} />
              </ListItemButton>
              {!open ? <span>Custom B.</span> : ''}
            </ListItem>
          )} */}

          {/* Before Admin Changes */}
          {/* {title === "Contacts" && leadManger === false && (
            <ListItem disablePadding sx={{ display: 'block' }}

            style={{
              backgroundColor: callLogs === props.history.location.pathname ? "#279f9f" : appTheme ? themeColors.sidebarBackgroundColor:themeColors.sidebarBackgroundColorDark,
              color: callLogs ===
                props.history.location.pathname ? "#FFFFFF" : "",
            }}
            onClick={() => {
              googleAnalyticsTabClick("CallLogs_Tab",user)
              props.history.push(callLogs);
            }}
            >
              <ListItemButton
                sx={{
                  minHeight: 48,
                  justifyContent: open ? 'initial' : 'center',
                  px: 2.5,
                }}

              >
                {callLogs === props.history.location.pathname ?                 <ListItemIcon
                  sx={{
                    minWidth: 0,
                    mr: open ? 3 : 'auto',
                    justifyContent: 'center',
                   color:"#fff",
                  }}
                >
                  <PhoneIcon />
                </ListItemIcon> :                 <ListItemIcon
                  sx={{
                    minWidth: 0,
                    mr: open ? 3 : 'auto',
                    justifyContent: 'center',
                    ...iconColor
                  }}
                >
                  <PhoneIcon />
                </ListItemIcon>}
                <ListItemText primary={"Call Logs"} sx={{ opacity: open ? 1 : 0 }} />
              </ListItemButton>
              {!open ? <span>Call Logs</span> : ''}
            </ListItem>
            
          )} */}

          {/* After Admin Changes */}
          {(user.profile === "Sales" || user.profile === "Team Lead") && (
            <ListItem disablePadding sx={{ display: 'block' }}

              style={{
                backgroundColor: callLogs === props.history.location.pathname ? "#279f9f" : appTheme ? themeColors.sidebarBackgroundColor : themeColors.sidebarBackgroundColorDark,
                color: callLogs ===
                  props.history.location.pathname ? "#FFFFFF" : "",
              }}
              onClick={() => {
                googleAnalyticsTabClick("CallLog_Tab",user)
                props.history.push(callLogs);
              }}
            >
              <ListItemButton
                sx={{
                  minHeight: 48,
                  justifyContent: open ? 'initial' : 'center',
                  px: 2.5,
                }}

              >
                {callLogs === props.history.location.pathname ? <ListItemIcon
                  sx={{
                    minWidth: 0,
                    mr: open ? 3 : 'auto',
                    justifyContent: 'center',
                    color: "#fff",
                  }}
                >
                  <PhoneIcon />
                </ListItemIcon> : <ListItemIcon
                  sx={{
                    minWidth: 0,
                    mr: open ? 3 : 'auto',
                    justifyContent: 'center',
                    ...iconColor
                  }}
                >
                  <PhoneIcon />
                </ListItemIcon>}
                <ListItemText primary={"Call Logs"} sx={{ opacity: open ? 1 : 0 }} />
              </ListItemButton>
              {!open ? <span>Call Logs</span> : ''}
            </ListItem>

          )}

          {title !== "Drilldown" && operationManger !== true && (
            <ListItem disablePadding sx={{ display: 'block' }}
              style={{
                backgroundColor: "/help" ===
                  props.history.location.pathname ? "#279f9f" : appTheme ? themeColors.sidebarBackgroundColor : themeColors.sidebarBackgroundColorDark,
                color: "/help" ===
                  props.history.location.pathname ? "#FFFFFF" : "", cursor: 'pointer'
              }}
              onClick={() => {
                googleAnalyticsTabClick("Help_Tab",user)
                props.history.push("/help");
              }}
            >
              <ListItemButton
                sx={{
                  minHeight: 48,
                  justifyContent: open ? 'initial' : 'center',
                  px: 2.5,
                }}
              >
                {"/help" ===
                  props.history.location.pathname ?
                  <ListItemIcon
                    sx={{
                      minWidth: 0,
                      mr: open ? 3 : 'auto',
                      justifyContent: 'center',
                      color: "#fff"
                    }}
                  >
                    <InfoIcon />
                  </ListItemIcon>
                  :
                  <ListItemIcon
                    sx={{
                      minWidth: 0,
                      mr: open ? 3 : 'auto',
                      justifyContent: 'center',
                      ...iconColor
                    }}
                  >
                    <InfoIcon />
                  </ListItemIcon>
                }
                <ListItemText primary={"Help"} sx={{ opacity: open ? 1 : 0 }} />
              </ListItemButton>
              {!open ? <span style={{ marginLeft: "17px" }}>Help</span> : ''}
            </ListItem>
          )}

          {/* <ListItem disablePadding sx={{ display: 'block' }}
            style={{
              backgroundColor: "/help" ===
                props.history.location.pathname ? "#279f9f" : appTheme ? themeColors.sidebarBackgroundColor : themeColors.sidebarBackgroundColorDark,
              color: "/help" ===
                props.history.location.pathname ? "#FFFFFF" : "", cursor: 'pointer'
            }}
            onClick={() => {
              props.history.push("/help");
            }}
          >
            <ListItemButton
              sx={{
                minHeight: 48,
                justifyContent: open ? 'initial' : 'center',
                px: 2.5,
              }}
            >
              {"/help" ===
                props.history.location.pathname ?
                <ListItemIcon
                  sx={{
                    minWidth: 0,
                    mr: open ? 3 : 'auto',
                    justifyContent: 'center',
                    color: "#fff"
                  }}
                >
                  <InfoIcon />
                </ListItemIcon>
                :
                <ListItemIcon
                  sx={{
                    minWidth: 0,
                    mr: open ? 3 : 'auto',
                    justifyContent: 'center',
                    ...iconColor
                  }}
                >
                  <InfoIcon />
                </ListItemIcon>
              }
              <ListItemText primary={"Help"} sx={{ opacity: open ? 1 : 0 }} />
            </ListItemButton>
            {!open ? <span style={{ marginLeft: "17px" }}>Help</span> : ''}
          </ListItem> */}
          
        </List>
      </Drawer>
      {lockSideNavbar && <div className="leftSideLocked"></div>}
    </Box >
  );
}
const mapStateToProps = (state: any) => {
  return {
    user: state.user.data,
    appTheme:state.theme.isLightMode,
    organizationData: state.organization.organizationData,
    userPreference:state.userPreference.data,
    lockSideNavbar: state.organization.lockSideNavbar,
    accessAllowedMarketingAutomation: state.organization.accessAllowedMarketingAutomation,
    showReportTab: state.lqcReportData.showReportTab,
    hasActiveWAPackage: state.organization.hasActiveWAPackage,
     WAAgentActiveStatus: state.organization.WAAgentActiveStatus,
  };
};

export default connect(mapStateToProps)(MiniDrawer);